import OpenTrades from "./components/OpenTrades";
import ProfitableAccount from "./components/ProfitableAccount";
import ProfitablePairs from "./components/ProfitableLosingPairs";

const Analytics = () => {
  return (
    <div className="grid gap-3">
      <div className="border-2 border-light rounded-[10px] p-5 ">
        <h2 className="text-title font-semibold mb-5">Top 20 Profitable Accounts</h2>
        <ProfitableAccount />
      </div>
      <div className="border-2 border-light rounded-[10px] p-5">
        <div className="grid sm:grid-cols-2 gap-3">
          <div>
            <h2 className="text-title font-semibold text-center  mb-5">Profitable Trades</h2>
            <div className="border border-light rounded-[10px] p-5">
              <OpenTrades type="ProfitableTrades" />
            </div>
          </div>
          <div>
            <h2 className="text-title font-semibold text-center  mb-5">Losing Trades</h2>
            <div className="border border-light rounded-[10px] p-5">
              <OpenTrades type="LosingTrades" />
            </div>
          </div>
        </div>
      </div>
      {/* <ProfitablePairs /> */}
    </div>
  );
};

export default Analytics;
